module.exports = __webpack_public_path__ + "img/CM-BS-25-CDJR-Playful.0d13df96.jpg";